import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service'; // Adjust import path if necessary

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isAdmin = this.authService.isCurrentUserAdmin();
    
    if (!isAdmin) {
      // Redirect to home page or access denied page if user is not admin
      this.router.navigate(['/']);
      return false;
    }
    
    return true;
  }
}
